import styled, { css } from 'styled-components';
import { Menu as MenuIcon } from '@mui/icons-material';
import { Typography } from '../typography';
import { smallScreenSize, useIsSmallScreen } from '../../hooks';
import { IconButton } from '../button';
import LOGO_SVG from '../../images/Logo.svg';
import LOGO_PRIMARY_SVG from '../../images/LogoPrimary.svg';

interface LogoProps {
  isOpen: boolean;
  isInvert?: boolean;
  handleChangeDrawer?: () => void;
}

const LogoWrapper = styled.div<LogoProps>`
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  align-items: center;

  width: calc(100% + 3.2rem);
  height: 6.8rem;
  margin-left: -1.6rem;
  padding: 0 1.6rem;
  border-bottom: 0.1rem solid var(--gray-80);
  transition: width 0.3s, margin 0.3s, padding 0.3s;

  & > *:nth-child(1) {
    transition: margin 0.3s;
  }
  & > *:nth-child(2) {
    transition: font-size 0.3s;
  }

  ${(props) =>
    !props.isOpen &&
    css`
      width: 100%;
      margin-left: 0;
      padding: 0;

      & > *:nth-child(1) {
        margin: 0 1.4rem;
      }
      & > *:nth-child(2) {
        font-size: 0;
      }
    `}

  ${(props) =>
    props.isInvert &&
    css`
      border-bottom: none;
    `}

  @media (max-width: ${smallScreenSize}px) {
    grid-template-columns: minmax(0, max-content) 1fr;
  }
`;

const LogoBase = styled.div<{ isInvert?: boolean }>`
  width: 4rem;
  max-width: 100%;
  height: 3.4rem;
  margin-right: 0.8rem;
  margin-left: 1.6rem;
  background-image: url(${LOGO_SVG});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  transition: max-width 0.3s;

  ${(props) =>
    props.isInvert &&
    css`
      background-image: url(${LOGO_PRIMARY_SVG});
    `}
`;

const MenuIconButton = styled(IconButton)<{ isOpen: boolean }>`
  ${(props) =>
    !props.isOpen &&
    css`
      pointer-events: none;
      opacity: 0;
    `}
`;

export const Logo: React.FC<LogoProps> = ({
  isOpen,
  isInvert = false,
  handleChangeDrawer,
  ...props
}: LogoProps) => {
  const isSmallScreen = useIsSmallScreen();

  return (
    <LogoWrapper isOpen={isOpen} isInvert={isInvert} {...props}>
      <LogoBase isInvert={isInvert} />
      <Typography variant={'h6'} weight={'bold'} color={isInvert ? '--primary-100' : '--white'}>
        TEZPORT
      </Typography>
      {isSmallScreen && handleChangeDrawer && (
        <MenuIconButton isOpen={isOpen} iconColor="--white" onClick={handleChangeDrawer}>
          <MenuIcon />
        </MenuIconButton>
      )}
    </LogoWrapper>
  );
};
